import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import Loader from "./Loader";
import fileDownload from "js-file-download";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { _get,_post,baseURL } from "../utils/apiServices";

export default function CheckboxList() {
  const values = useSelector((state) => state.fieldValues);
  const [pdfFiles, setPdf] = useState([]);
  const [checked, setChecked] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkedHeader, setCheckedHeader] = useState(false);


  const showFields = async () => {
    setLoading(true);
    try {
      const { data } = await _get("/api/posts/show");
      setPdf(data.pdfFiles);
      setLoading(false);
    } catch (error) {
      console.log(error.response.data.error);
    }
  };

  useEffect(() => {
    showFields();
  }, []);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleHeaderClick = () => {
    if (!checkedHeader) {
      setChecked(Array.from({ length: pdfFiles.length }, (_, i) => i));
    } else {
      setChecked([]);
    }
    setCheckedHeader(!checkedHeader);
  };

  const sendCheckedFiles = async () => {
    // Filter pdfFiles to include only checked files
    const nomeScuolaValue = values["nome_scuola"];
    if (!nomeScuolaValue || nomeScuolaValue.trim() === "") {
      // Raise an alert if 'nome_scuola' is empty
      toast.error("Campo Nome Scuola Obbligatorio")
      return false; // Prevent form submission
    }
    toast.loading('Generazione iniziata, attendere...');
    const checkedFilesInfo = pdfFiles.filter((file, index) =>
      checked.includes(index)
    );
    
    // Convert the filtered array to the format required by your backend
    // This example assumes your backend expects an array of strings (e.g., file names)
    const filesToSend = checkedFilesInfo.map((file) => file._id); // Adjust 'name' according to your data structure

    // Prepare the form values for submission
    const formData = {
      files: filesToSend,
      fields: { ...values }, // Spread the form values into the payload
    };

    try {
      // Send the list of checked files to the server
      const response = await _post(
        "/api/process-files",
        formData
      );
      

      const downloadData = JSON.parse(response.data.downloadLinks);


      const handleDownload = (url, title) => {
        // Assuming the URL is relative and needs to be prefixed with the base URL
        url = `${baseURL}${url}`;


        // Use Axios to get the file as a blob
        axios
          .get(url, {
            responseType: "blob",
          })
          .then((res) => {
            // Use a library like file-saver to save the file
            // Note: You might need to install 'file-saver' package if you haven't already
            fileDownload(res.data, `${title.replace(/\s+/g, "_")}.pdf`);
          });
      };

      // Iterate over each object in the array
      for (let obj of downloadData) {
        // Get the keys of the current object
        let keys = Object.keys(obj);

        // Iterate over each key
        for (let key of keys) {
          handleDownload(obj[key], key);
        }
      }
      toast.dismiss();
      toast.success("File Scaricati")
      // Optionally, handle success (e.g., show a message)
      //alert("Files sent successfully!");
    } catch (error) {
      toast.dismiss();
      // Handle error (e.g., show an error message)
      console.error("Error sending files:", error);
      toast.error("Generazione Fallita", error)
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          justifyContent: "center",
        }}
      >
        <FormGroup
          sx={{
            width: "100%", // Ensure FormGroup takes the full width
            display: "flex", // Use flexbox for better control over alignment
            alignItems: "center", // Vertically center the FormControlLabel
          }}
        >
          <FormControlLabel
            control={
              <Checkbox checked={checkedHeader} onChange={handleHeaderClick} />
            }
            label="Spunta per selezionare/deselezionare tutti i documenti"
          />
        </FormGroup>
      </Box>
      <Divider sx={{ bgcolor: "#2196F3", height: "3px" }} />

      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {loading ? (
          <Loader />
        ) : (
          pdfFiles.map((value, index) => {
            const labelId = `checkbox-list-label-${index}`;

            return (
              <ListItem key={value} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={handleToggle(index)}
                  dense
                >
                  <ListItemIcon id={`id_${index}`}>
                    <Checkbox
                      edge="start"
                      checked={checked.indexOf(index) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": `${index}` }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.title} />
                </ListItemButton>
              </ListItem>
            );
          })
        )}
      </List>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center", // Center items horizontally
          padding: "5px",
          flexGrow: 1, // Allow this Box to grow and fill available space
        }}
      >
        <Button variant="contained" onClick={sendCheckedFiles}>
          Clicca qui per generare i documenti
        </Button>
      </Box>
    </>
  );
}
